import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, RouterEvent, NavigationEnd } from '@angular/router';
import { CatalogService } from '@serengeti/serengeti-app';
import { CatalogLauncherWizardComponent } from '@serengeti/serengeti-app';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
	selector: 'app-software-catalog-launcher',
	templateUrl: './launcher.component.html',
	styleUrls: ['./launcher.component.scss']
})
export class SoftwareCatalogLauncherComponent implements OnInit {

	selectedCatalog: any;
	selectedTenant: any;

	routeSubscription: Subscription;

	@ViewChild('wizard', {static: false}) wizard: CatalogLauncherWizardComponent;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private catalogService: CatalogService
	) {
		this.routeSubscription = this.router.events.pipe(
			filter((event: RouterEvent) => event instanceof NavigationEnd)
		).subscribe(() => {
			const catalogId = this.route.snapshot.paramMap.get('catalogId');
		
			this.catalogService.getSummary(catalogId).subscribe((catalog: any) => {
				this.selectedCatalog = catalog;
			});
		});
	}

	ngOnInit() {
	}

	ngOnDestroy() {
		if (this.routeSubscription) {
			this.routeSubscription.unsubscribe();
		}
	}

	onTenantSelected(selectedTenant: any) {
		this.selectedTenant = selectedTenant;
	}

	getSoftwareTemplateApps(softwareTemplates: any[], resourceTemplate: any): any[] {
		return this.catalogService.getSoftwareTemplateApps(softwareTemplates, resourceTemplate);
	}

	getSoftwareTemplate(softwareTemplates: any[], resourceTemplate: any) {
		return this.catalogService.getSoftwareTemplate(softwareTemplates, resourceTemplate);
	}

	onSoftwareConfigure($event: any) {
		this.wizard.onSoftwareConfigure($event);
	}
}
